/// <reference path="../../../app.definition.ts" />

import angular from "angular";
import { Subject } from "@common/model/subject";
export class GalleryPopupController {
  images: any;
  $uibModalInstance: any;
  mode: string;
  edit: boolean;
  subject: Subject;
  addNew: boolean;

  static $inject = ['images', '$uibModalInstance', 'mode', 'subject', 'allowNew', '$scope', '$rootScope', '$uibModalStack', 'BroadcastService'];
  constructor(
    images,
    $uibModalInstance,
    mode,
    subject,
    allowNew,
    $scope,
    $rootScope,
    $uibModalStack,
    BroadcastService
  ) {
    var galleryPopupVm: any = this;
    galleryPopupVm.images = images;
    galleryPopupVm.mode = mode;
    galleryPopupVm.subject = subject;
    galleryPopupVm.addNew = allowNew;

    galleryPopupVm.cancel = () => {
      $uibModalInstance.dismiss();
    }

    galleryPopupVm.save = () => {
      $uibModalInstance.close(images);
    }

    if (!!galleryPopupVm.mode && galleryPopupVm.mode == 'edit') {
      galleryPopupVm.edit = true;
    } else {
      galleryPopupVm.edit = false;
    }

    BroadcastService.registerCallBack('close-gallery', $rootScope.$id, () => {
      $uibModalStack.dismissAll();
    });
    galleryPopupVm.$onDestroy = () => {
      BroadcastService.removeCallBack('close-gallery', $rootScope.$id);
    }
  }
}


angular.module('eCareVault.common.popUp')
  .controller('GalleryPopupController', GalleryPopupController);
